module.exports = __webpack_public_path__ + "h5/img/装小白.3fe7b676.jpg";